import React from "react";
import MyLocationIcon from '@material-ui/icons/MyLocation';
import LocationDisabledIcon from "@material-ui/icons/LocationDisabled";
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from '@material-ui/core/Tooltip';

export default function UserLocationButton({ status, onClick, ...props }) {
    let color, disabled, icon;
    switch (status) {
        case "pending":
            color = "default";
            disabled = false;
            icon = <MyLocationIcon />;
            break;
        case "loading":
            disabled = true;
            color = "default";
            icon = <CircularProgress size={24} color="primary" />
            break;
        case "disabled":
            color = "default";
            icon = <LocationDisabledIcon />;
            disabled = true;
            break;
        case "ok":
            color = "primary";
            icon = <MyLocationIcon />;
            disabled = false;
            break;
        default:
            break;
    }
    return (
        <Tooltip placement="top" title="Click to move pin to browser's location">
            <IconButton disabled={disabled} color={color} onClick={onClick}>
                {icon}
            </IconButton>
        </Tooltip>
    )
}